export default __webpack_public_path__ + "static/media/mypathguider.d1efd18c.png";